import * as React from 'react';

import { AreaGridUtils } from '../util/AreaGridUtils';
import { useOrganixContext } from './IOrganixContext';

type Ref = HTMLCanvasElement;

const OrganixCanvas = React.forwardRef<Ref, {}>((props: {}, ref) => {
  const ctx = useOrganixContext();

  const getFactor = () => {
    let factor = 1;
    let width = ctx.simulation.area.resolution * factor;
    while(width < 200) {
      factor++;
      width = ctx.simulation.area.resolution * factor;
    }
    return factor;
  }  

  return (
    <canvas 
      ref={ref}
      style={{ imageRendering: 'pixelated', visibility: 'hidden' }}
      width={ctx.simulation.area.resolution * getFactor()} height={AreaGridUtils.verticalResolution(ctx.simulation.area.rect, ctx.simulation.area.resolution) * getFactor()}
    />
  );
});

export { OrganixCanvas }
